// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';

import ClaimIncentiveProgram from '@deere/cps-it.warranty-model-factory/lib/claim-incentive-program';
import EditableField from '../../../../shared/components/editable-field';
import {FormattedMessage} from 'react-intl';
import LabeledFormInput from '../../../../shared/components/labeled-form-input';
import ProgramNameDropDown from './program-name-dropdown';
import {getFieldClassName} from '../../../shared/services/claim-shared-helper';
import {translate} from '../../../../shared/services/translation-service';

const ProgrameNameDropDown = ({className, errorMessage, highlightClass, isEditable, isValid = true, label, selectedValue, vsrMessage, ...props}) =>
    <LabeledFormInput
        className={getFieldClassName(className, isValid, highlightClass)}
        label={label}
    >
        <EditableField
            isEditable={isEditable}
            value={selectedValue.programName ? `${selectedValue.programName} - ${selectedValue.programDescription}` : ''}
        >
            <ProgramNameDropDown
                {...props}
                className={className}
                value={selectedValue.programName}
            />
        </EditableField>
        {!isValid && errorMessage && isEditable &&
            <span className='error-message'>
                <FormattedMessage id={errorMessage}/>
            </span>
        }
        {
            vsrMessage && <span className='vsr-message'>{`${vsrMessage} (${translate('SAVE_TO_VALIDATE')})`}</span>
        }
    </LabeledFormInput>;

ProgrameNameDropDown.displayName = 'ProgrameNameDropDown';
ProgrameNameDropDown.propTypes = {
    className: PropTypes.string.isRequired,
    errorMessage: PropTypes.string,
    highlightClass: PropTypes.string,
    includeKeyInDropDown: PropTypes.bool,
    isEditable: PropTypes.bool.isRequired,
    isValid: PropTypes.bool,
    label: PropTypes.string.isRequired,
    list: PropTypes.arrayOf(PropTypes.instanceOf(ClaimIncentiveProgram)).isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    selectedValue: PropTypes.instanceOf(ClaimIncentiveProgram).isRequired,
    showPlaceholder: PropTypes.bool,
    vsrMessage: PropTypes.string
};
export default ProgrameNameDropDown;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-fields/labeled-incentive-program-name-dropdown.js